import { toQueryString } from ".";
import { AdvertBanner } from "../model/advert-banner/advert-banner";
import { AdvertBanners, AdvertBannersQuery } from "../model/advert-banner/advert-banners";
import { apiSlice } from "../stores/base/api-slice";

const advertBannerEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		advertBanners: builder.query<AdvertBanners, AdvertBannersQuery>({
			query: query => ({
				url: "/advert-banner" + toQueryString(query),
				method: "GET",
			})
		}),
		stopAdvertBanner: builder.mutation<void, { id: number }>({
            query: ({ id }) => ({
                url: `/advert-banner/${id}/stop`,
                method: "POST",
            }),
        }),
		createAdvertBanner: builder.mutation<void, FormData>({
			query: (formData) => ({
				url: "/advert-banner",
				method: "POST",
				body: formData,
			}),
		}),
		getActiveAdvertBanner: builder.query<AdvertBanner, void>({
			query: () => ({
				url: "/advert-banner/active",
				method: "POST",
			}),
		}),
		clickAdvertBanner: builder.mutation<AdvertBanner, { id: number }>({
			query: ({ id }) => ({
				url: `/advert-banner/${id}/click`,
				method: "POST",
			}),
		}),
	})
});

export const { 
	useLazyAdvertBannersQuery,
	useStopAdvertBannerMutation,
	useCreateAdvertBannerMutation,
	useGetActiveAdvertBannerQuery,
	useClickAdvertBannerMutation
} = advertBannerEndpoints;
